module.exports = __webpack_public_path__ + "img/expenditureItemIcon4.17f403b3.png";